import { toFiniteNumberOrNull } from './index';

export function getEnvVar(name: string): string {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Environment variable ${name} is not defined`);
  }
  return value;
}

export function readPositiveIntEnvVar(name: string): number | null {
  const parsed = toFiniteNumberOrNull(process.env[name]);
  return parsed !== null && Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}
